import { Controller } from "@hotwired/stimulus"
import { useTransition } from 'stimulus-use'

export default class extends Controller {
  static targets = ["menu"]

  eventCreated = false

  connect() {
    if (this.hasMenuTarget) {
      useTransition(this, { element: this.menuTarget })
    }
  }

  async toggle() {
    // data-transition-pending sygnalizuje trwanie async enter()/leave() z useTransition.
    // Queryowalne z testów przez wait_for_transitions / assert_no_css("[data-transition-pending]").
    this.element.dataset.transitionPending = ""

    if (this.eventCreated === false) {
      const fn = this.outsideHide.bind(this)
      this.eventCreated = fn
      document.addEventListener("click", fn)
    } else {
      this.removeEvent()
    }

    try {
      if (this.transitioned) {
        await this.leave()
      } else {
        await this.enter()
      }
    } finally {
      delete this.element.dataset.transitionPending
    }
  }

  hide() {
    this.leave()
    this.removeEvent()
  }

  outsideHide(event) {
    // this.hide(event)
    if (!this.element.contains(event.target) && (this.hasMenuTarget && !this.menuTarget.classList.contains("hidden"))) {
      this.leave()
      this.removeEvent()
    }
  }

  removeEvent() {
    if (this.eventCreated !== false) {
      document.removeEventListener("click", this.eventCreated)
      this.eventCreated = false
    }
  }

  disconnect() {
    this.removeEvent()
  }
}
